import React from 'react';
import './Footer.css';

function Footer () {
    return (
        <div className="Footer">
            <li>James Dalziel</li>
            <li>2026-02-18</li>
        </div>
    )
}

export default Footer